"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_AuditEvent_Entity = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_Coding_1 = require("./RTTI_Coding");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_base64Binary_1 = require("../Scalar/RTTI_base64Binary");
var RTTI_AuditEvent_Detail_1 = require("./RTTI_AuditEvent_Detail");
exports.RTTI_AuditEvent_Entity = t.recursion('IAuditEvent_Entity', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        what: RTTI_Reference_1.RTTI_Reference,
        type: RTTI_Coding_1.RTTI_Coding,
        role: RTTI_Coding_1.RTTI_Coding,
        lifecycle: RTTI_Coding_1.RTTI_Coding,
        securityLabel: t.array(RTTI_Coding_1.RTTI_Coding),
        name: t.string,
        _name: RTTI_Element_1.RTTI_Element,
        description: t.string,
        _description: RTTI_Element_1.RTTI_Element,
        query: RTTI_base64Binary_1.RTTI_base64Binary,
        _query: RTTI_Element_1.RTTI_Element,
        detail: t.array(RTTI_AuditEvent_Detail_1.RTTI_AuditEvent_Detail)
    });
});
//# sourceMappingURL=RTTI_AuditEvent_Entity.js.map